import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import { Route, Router, RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {LoginService} from '../../login-service';
 import {ToastrModule} from 'ngx-toastr'
declare var gapi: any;
declare var FB: any;
import { ViewChild,ElementRef } from '@angular/core'
import {SocialLogins} from '../../sociallogins'
import Swal from 'sweetalert2';
import { CustomValidators } from './custom-validators';
@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html'
})
export class RegisterComponent {
  @ViewChild('signupRef', {static: true }) signupElement: ElementRef;
  buttonname:string;
  registerForm: FormGroup;
  submitted = false;
  tabtype:string='i';
  firstName:string;
  userType:string;
  lastName:string;
  emailAddress:string;
  newPassword:string;
  confirmPassword:string;
 tabValue=0;
 userID:any;
  usersList: any;
  auth2: any;
  show: boolean;
  Name: any;
toastr: any;
  usercreatedby: string;
  subject: any;
  description: string;
  verifymail: string;
  clickverify: boolean=false;
  userTname: string;
  isverified: string;
  tab: string;
  tabValue1: string;
  checkmail: boolean;
  mailerror: boolean=false;
  bidSubmitted:string;
  bidacoll:boolean=false;
  constructor(private toasterr:ToastrModule, private formBuilder: FormBuilder,private router:Router,private loginService:LoginService,private activateRoute:ActivatedRoute,private socialLogins:SocialLogins) { 
    this.userType="1";
  
  }
  ngOnInit(): void {
    this.bidSubmitted=localStorage.getItem('BidSubmitted');
    if(this.bidSubmitted=='true'){
      this.tabtype='c';
      this.bidacoll=true;
      // localStorage.setItem('userType',"2");
    }
    else{
    this.tabtype='i';
    localStorage.setItem('BidSubmitted','false');
    // localStorage.setItem('userType',"1");
    }
    this.userTname='1';
    let json11={
      value:1,
      type:2,
    }
    json11.value=3
    console.log(json11)
    
    this.usercreatedby=localStorage.getItem("USERCREATEDBY")
    localStorage.setItem('PROCESS','signup');
 let json=localStorage.getItem('collabojson')
 var json1=JSON.parse((json))
 console.log(json1)
    this.GetUsers();
    localStorage.setItem('SIGNEDUPAS',this.tabtype);
    this.registerForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
       newPassword: ['', [Validators.required, Validators.minLength(8),
        CustomValidators.patternValidator(/\d/, { hasNumber: true }),
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
       
      ]],
       retypePassword: ['', [Validators.required]]
  }, { 
    validator: this.ConfirmedValidator('newPassword', 'retypePassword')
  }
  );
  this.googleInitialize();
  }

  login()
  {
    this.bidacoll=false;
    localStorage.setItem('BidSubmitted','false');
  }
  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
  
      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);
  
      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }
  googleInitialize() {
    window['googleSDKLoaded'] = () => {
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          client_id: '754184839525-t3con2lvf5513oekl5k81mpivve5868f.apps.googleusercontent.com',
          cookie_policy: 'single_host_origin',
          scope: 'profile email'
        });
        this.prepareLogin();
      });
    }
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));
  }
sendmail()
{
  if(this.usersList.length>0)
    {
      let validateUser=this.usersList.filter(x=>x.email.toLowerCase().toString()===this.emailAddress.toLowerCase().toString());
      console.log(validateUser.length)
      console.log(validateUser)
      if(validateUser.length>0)
      {
        //this.loginService.showError("This email already exists",'error')
       this.mailerror=true;
        return;
      }
      else{this.mailerror=false;}
    }
  this.tab=this.tabtype;
  if(this.tabtype=='i')
  {
  localStorage.setItem('userType',"1");
  }
  else{
    localStorage.setItem('userType',"2");
  }
  localStorage.setItem('isverified',"y");
  this.subject="email verification";
  this.description="Please click on below accept button to verify.....";
  this.loginService.SendMail(this.emailAddress,this.subject,this.description).subscribe(data=>{
    console.log(data)
       this.loginService.showSuccess("Mail Sent Successfuly","");
       this.subject="";
       this.description="";
       
   })
  this.isverified='y';
  
   
}
  prepareLogin() {
    this.auth2.attachClickHandler(this.signupElement.nativeElement, {},
      (googleUser) => {
        let profile = googleUser.getBasicProfile();
        this.show = true;
        this.Name =  profile.getName();
        let userType:string;
if(this.tabtype=='Initiator')
{
  userType="1";
   localStorage.setItem('userType',"1");
}
    else{
      userType="2";
      localStorage.setItem('userType',"2");
    }  
        this.socialLogins. usernameparm = profile.getName();
        this.registerForm.value.email = profile.getEmail();   
        this.registerForm.value.firstName = profile.getGivenName();
        this.registerForm.value.lastName = profile.getFamilyName();
this.socialLogins.usertypeidparm=userType;
this.socialLogins.passwordparm="";
       this.socialLogins.socialusersparm="google";
       this.onSubmit();
    
      }, (error) => {
        alert(JSON.stringify(error, undefined, 2));
      });
  }
  GetUsers(){
    this.loginService.GetUsers(this.userType).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
              this.usersList=JSON.parse(JSON.stringify(data));
      });
  }

  get f() { return this.registerForm.controls; }
  TabChanging(type) {
    this.tabtype = type;
    localStorage.setItem('SIGNEDUPAS',this.tabtype);
    if(this.tabtype=='i')
    {
      this.tabValue=1;
      localStorage.setItem('userType',"1");
      
    }else{
      this.tabValue=2;
      localStorage.setItem('userType',"2");
    }
  }
  onSubmit() {
    this.GetUsers();
    let validateuser1=this.usersList.filter(x=>x.id==this.userID)
    console.log(validateuser1)
    this.tabValue1=localStorage.getItem("userType")
    // this.isverified=localStorage.getItem("isverified")
    // if(this.verifymail=="true")
    // {
    this.firstName=this.registerForm.value.firstName;
    this.lastName=this.registerForm.value.lastName;
    this.emailAddress=this.registerForm.value.email;
this.newPassword=this.registerForm.value.newPassword;
this.confirmPassword=this.registerForm.value.retypePassword;
      this.submitted = true;
      if (this.registerForm.invalid) {
          return;
      }
      else
      {
        // if(validateuser1[0].email==this.emailAddress)
        // {
        //   return;
        // }
        // else{
        const jsonData = {
          firstnameparm:this.firstName,
      lastnameparm:this.lastName,
      usernameparm:this.registerForm.value.firstName+" "+this.registerForm.value.lastName,
      emailparm:this.emailAddress,
      passwordparm:this.newPassword,
      usertypeidparm:this.tabValue1,
      isverifiedparam:'n',
      socialusersparm:"",
      issubscribedparam:"n"
        };
        if(this.usersList.length>0)
        {
          let validateUser=this.usersList.filter(x=>x.email.toLowerCase().toString()===this.emailAddress.toLowerCase().toString());
          console.log(validateUser.length)
          console.log(validateUser)
          if(validateUser.length>0)
          {
            //this.loginService.showError("This email already exists",'error')
           this.mailerror=true;
            return;
          }
          else{this.mailerror=false;
        this.loginService.SaveUsers(jsonData).subscribe(data=>{
          this.userID=data['_body'].toString();
          localStorage.setItem('USERID',this.userID);
          if(this.usercreatedby=="admin")
          {
            this.loginService.showSuccess('user created successfully','');
           this.ClearFiields();
          }
          this.GetUsers();
        });

      }
          
    // }
  }
      }
     
  this.tab=this.tabtype;
  localStorage.setItem('SIGNEDUPAS',this.tabtype);
  if(this.tabtype=='i')
  {
  localStorage.setItem('userType',"1");
  }
  else{
    localStorage.setItem('userType',"2");
  }
  localStorage.setItem('isverified',"y");
  this.subject="email verification";
  this.description="Please click on below accept button to verify.....";
  console.log(this.userID)
 this.checkmail=true;
  this.isverified='y';
    // }
    // else
    // {
    //   Swal.fire("Please Verify the email first");
    // }
  }
  ClearFiields(){
    this.firstName="";
    this.lastName='';
    this.emailAddress="";
    this.newPassword="";
    this.confirmPassword="";

  }

  ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

}
